import React, { useState } from "react";
import { ProductItem } from "../../../domain/entities/ProductItem";

interface CardProductComponentsProps {
  productItems: ProductItem[];
  onProductId: (productid: number, price: number) => void;
}

const CardProductComponents: React.FC<CardProductComponentsProps> = ({productItems, onProductId}) => {
  const [activeCard, setActiveCard] = useState<number | null>(null); // State for the active card

  const handleButtonClick = (id: number, price: number) => {
    setActiveCard(id); // Update the active card
    onProductId(id, price);
  };

  return (
    <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {productItems.map((card) => (
        <div
          key={card.id}
          className={`p-4 border rounded-lg text-center bg-white shadow-md transition-transform transform ${
            activeCard === card.id ? "shadow-lg" : ""
          }`}
        >
          <h3 className="text-lg font-bold text-gray-800 font-poppins">{card.name}</h3>
          <label className="text-xs font-semibold text-gray-600 font-poppins">Up to</label>
          <p className="text-2xl text-pink-800 font-bold font-poppins">
            <strong>{card.speed}</strong>
          </p>
          <div className="flex gap-1 justify-center">
            <p className="text-sm text-gray-500 mt-1 font-poppins">Rp</p>
            <p className="text-xl font-bold text-gray-800 font-poppins">{new Intl.NumberFormat("ID").format(card.price)}</p>
            <p className="text-sm text-gray-500 mt-1 font-poppins">/ bulan</p>
          </div>
          <button
            className={`w-full py-2 mt-4 rounded-md ${
              activeCard === card.id ? "bg-pink-800 text-white hover:bg-pink-800" : "bg-gray-300 text-white hover:bg-pink-800"
            } font-bold font-poppins transition-colors duration-300`}
            onClick={() => handleButtonClick(card.id, card.price)} // Set the card as active
          >
            Pilih
          </button>
        </div>
      ))}
    </div>
  );
};

export default CardProductComponents;